import { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

// SVG React components for Contact section icons
export const AddressIcon = ({ className = '', ...props }: IconProps) => (
  <svg 
    className={`w-6 h-6 ${className}`} 
    viewBox="0 0 36 36" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="18" cy="18" r="16" stroke="currentColor" strokeWidth="2" fill="currentColor" className="text-cyan-500/20" />
    <path d="M18 10a6 6 0 016 6c0 4-6 10-6 10s-6-6-6-10a6 6 0 016-6z" stroke="currentColor" strokeWidth="2" fill="currentColor" className="text-cyan-500/30"/>
    <circle cx="18" cy="16" r="2" fill="currentColor" className="text-cyan-400" />
  </svg>
);

export const PhoneIcon = ({ className = '', ...props }: IconProps) => (
  <svg 
    className={`w-6 h-6 ${className}`} 
    viewBox="0 0 36 36" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="4" y="4" width="28" height="28" rx="8" fill="currentColor" stroke="currentColor" strokeWidth="2" className="text-green-500/20" />
    <path d="M12 16c1.5 3 4.5 6 7.5 7.5l2.5-2.5c.5-.5 1.25-.5 1.75 0l2 2c.5.5.5 1.25 0 1.75-1.5 1.5-3.5 2-5.5 2C13 27 9 23 9 18.5c0-2 .5-4 2-5.5.5-.5 1.25-.5 1.75 0l2 2c.5.5.5 1.25 0 1.75l-2.5 2.5z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      fill="currentColor"
      className="text-green-400"
    />
  </svg>
);

export const EmailIcon = ({ className = '', ...props }: IconProps) => (
  <svg 
    className={`w-6 h-6 ${className}`} 
    viewBox="0 0 36 36" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="4" y="8" width="28" height="20" rx="6" fill="currentColor" stroke="currentColor" strokeWidth="2" className="text-pink-500/20" />
    <path d="M8 12l12 8 12-8" stroke="currentColor" strokeWidth="2" className="text-pink-400"/>
    <path d="M8 12v12h24V12" stroke="currentColor" strokeWidth="1.5" className="text-pink-300"/>
  </svg>
);

export const ClockIcon = ({ className = '', ...props }: IconProps) => (
  <svg 
    className={`w-6 h-6 ${className}`} 
    viewBox="0 0 36 36" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="18" cy="18" r="16" fill="currentColor" stroke="currentColor" strokeWidth="2" className="text-yellow-500/20" />
    <path d="M18 10v8l6 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="text-yellow-400"/>
  </svg>
);
